import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-nav-button',
    standalone: true,
    imports: [MatIconModule, MatButtonModule],
    template: `
        <button matIconButton type="button" (click)="toggle.emit()">
            <mat-icon class="leading-none">
                {{ icon }}
            </mat-icon>
        </button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppNavButtonComponent {
    @Input() icon: string;

    @Output() toggle = new EventEmitter<void>();
}
